var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F9CCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_32627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9979 25.1548C29.4791 21.1395 28.2679 14.8973 23.5333 12.4622C22.166 9.81441 19.4023 8 16.2227 8C11.6889 8 8.00048 11.6887 8.00048 16.2227C8.00048 18.2187 8.70704 20.1065 10.0019 21.6001L8.17481 23.4032C7.8045 23.7688 8.06102 24.4037 8.5836 24.4062L12.9959 24.4273C14.5165 26.6398 17.0283 28 19.7772 28C19.7828 28 27.4118 27.961 27.4163 27.9609C27.9371 27.9584 28.1966 27.3246 27.825 26.9579L25.9979 25.1548ZM11.2329 21.2038C9.90411 19.8725 9.17227 18.1035 9.17227 16.2227C9.17227 12.3348 12.3351 9.17188 16.2227 9.17188C20.1102 9.17188 23.2731 12.3348 23.2731 16.2227C23.2731 19.9482 20.3249 23.3035 15.994 23.2696L10.0074 23.2411L11.2298 22.0348C11.4609 21.8066 11.4623 21.4337 11.2329 21.2038ZM19.7772 26.8281C17.7212 26.8281 15.8101 25.9496 14.4817 24.4343C16.7123 24.449 16.1202 24.4453 16.2227 24.4453C21.5118 24.4453 25.4612 19.484 24.2183 14.304C27.4592 16.9514 27.7246 21.7954 24.767 24.7585C24.5375 24.9884 24.5389 25.3613 24.7701 25.5895L25.9925 26.7958C25.9878 26.7958 19.7817 26.8281 19.7772 26.8281Z",
    fill: "#505759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7265 14.4844H19.7574C20.081 14.4844 20.3433 14.222 20.3433 13.8984C20.3433 13.5748 20.081 13.3125 19.7574 13.3125H12.7265C12.4029 13.3125 12.1406 13.5748 12.1406 13.8984C12.1406 14.222 12.403 14.4844 12.7265 14.4844Z",
    fill: "#505759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7265 16.8281H19.7574C20.081 16.8281 20.3433 16.5658 20.3433 16.2422C20.3433 15.9186 20.081 15.6562 19.7574 15.6562H12.7265C12.4029 15.6562 12.1406 15.9186 12.1406 16.2422C12.1406 16.5658 12.403 16.8281 12.7265 16.8281Z",
    fill: "#505759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7265 19.1719H19.7574C20.081 19.1719 20.3433 18.9095 20.3433 18.5859C20.3433 18.2623 20.081 18 19.7574 18H12.7265C12.4029 18 12.1406 18.2623 12.1406 18.5859C12.1406 18.9095 12.403 19.1719 12.7265 19.1719Z",
    fill: "#505759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_32627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlIcon);
export default __webpack_public_path__ + "static/media/sl-icon.5d61a37ec30a8761a9bf4fe622bed445.svg";
export { ForwardRef as ReactComponent };